/**
 * Converts a country code to a country name.
 */
export const countryCodeToName = (code?: string | null, lang = 'en') =>
  // Sometimes, the backend returns "unknown" as the country code.
  code && code.length == 2
    ? new Intl.DisplayNames([lang], { type: 'region' }).of(code)
    : '';
